import { AttributeValue } from 'app/components/attributes/attributes.model';
import { Entity } from 'app/pages/product/product.model';


export class Team extends Entity
{
    
    description: string;
    creationDate: Date;
    members: Entity[];
    

    /**
     * Constructor
     *
     * @param team
     */
    constructor(team?)
    {
        team = team || {};
        super(team);
        this.description = team.description ;

        // this.createdBy= team.createdBy;
        this.creationDate = team.creationDate;
        this.members = team.members || [];

    }

}
